/**
 * 商户卖车记录
 */
import React from 'react';

import { Row, Col, DatePicker, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import Loading from '../../ui/Loading';


//商户选择
import MemberSelect from '../../crm/member/MemberSelect';

class TradeLogIndex extends React.Component {

    columns = [{
        title: '申请单编号',
        dataIndex: 'applicationId',
        width: '10%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '10%',
    }, {
        title: '车牌号',
        dataIndex: 'plateNo',
        width: '6%',
    }, {
        title: '商户',
        dataIndex: 'memberName',
        width: '15%',
    }, {
        title: '车辆',
        dataIndex: 'vehicleName',
        width: '15%',
    }, {
        title: '卖家',
        dataIndex: 'sellerName',
        width: '6%',
    }, {
        title: '买家',
        dataIndex: 'buyerName',
        width: '6%',
    }, {
        title: '车价',
        dataIndex: 'amount',
        width: '6%',
    }, {
        title: '上架时间',
        dataIndex: 'sellingTime',
        width: '10%',
    }, {
        title: '交易时间',
        dataIndex: 'billingTime',
        width: '10%',
    }];

    state = {
        loadData: '',
        queryData: {},
        loadingVisible: false    //导出遮罩
    };

    memberSelect = (res) => {
        let queryData = this.state.queryData;
        queryData.memberCode = res;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    //导出数据
    download = () => {
        let queryData = this.state.queryData;
        if (queryData.startDate == null || queryData.startDate === "") {
            messager.notify("请选择时间段进行导出！");
            return;
        }
        this.setState({ loadingVisible: true });
        queryData.pageNumber = 1;
        queryData.pageSize = 5000;
        http.download({
            url: '/tradeLog/download',
            data: queryData,
            fileName: "商家卖车记录.xlsx",
            success: (res) => {
                this.setState({ loadingVisible: false });
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.sellerName = value
        this.state.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={24}>
                                {/* <Input.Search
                                    placeholder="商户名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: '250px' }}
                                /> */}
                                <MemberSelect placeholder="商户" mall={1} allowClear={true} onChange={this.memberSelect} style={{ width: '250px', marginRight: '10px'  }} />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ margin: '0 10px' }} />
                                <Button type="primary" onClick={this.download} style={{ "float": "right" }}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/tradeLog/findTradeLogPage"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.loadingVisible} message="正在导出，请稍候..." />
            </div>
        )
    }
}

export default TradeLogIndex;